import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/admin/beta`;

export const betaAdminApi = (token) => {
  const h = { headers: { Authorization: `Bearer ${token}` } };
  return {
    overview: () => axios.get(`${BASE}/overview`, h).then((r) => r.data),
    testers: () => axios.get(`${BASE}/testers`, h).then((r) => r.data.testers),
    setSpots: (spots) => axios.put(`${BASE}/settings`, { spots }, h),
    patch: (pid, body) => axios.patch(`${BASE}/testers/${pid}`, body, h),
    uploadPhoto: (pid, file) => { const f = new FormData(); f.append('file', file); return axios.post(`${BASE}/testers/${pid}/photo`, f, h); },
    extend: (pid, days) => axios.post(`${BASE}/testers/${pid}/extend`, { days }, h),
    remove: (pid) => axios.post(`${BASE}/testers/${pid}/remove`, {}, h),
    remind: (pid) => axios.post(`${BASE}/testers/${pid}/remind`, {}, h),
    publish: (pid) => axios.post(`${BASE}/testers/${pid}/publish`, {}, h),
    lifetime: (pid) => axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/admin/beta-testers/${pid}/grant-lifetime`, {}, h),
    exportCsv: () => axios.get(`${BASE}/export.csv`, { ...h, responseType: 'blob' }).then((r) => {
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = 'practcom-beta-testers.csv'; a.click();
      URL.revokeObjectURL(url);
    }),
  };
};

export const photoUrl = (pid, v) => `${process.env.REACT_APP_BACKEND_URL}/api/beta/photo/${pid}?v=${encodeURIComponent(v || '')}`;

export const STATUS = {
  active: ['Active', 'bg-sky-100 text-sky-800'],
  ending_soon: ['Ending soon', 'bg-amber-100 text-amber-800'],
  ended: ['Ended', 'bg-rose-100 text-rose-800'],
  lifetime: ['Free for life', 'bg-emerald-100 text-emerald-800'],
  removed: ['Removed', 'bg-slate-200 text-slate-600'],
};
